import { render, staticRenderFns } from "./BindWeChatConfirm.vue?vue&type=template&id=267fa9c0&scoped=true"
import script from "./BindWeChatConfirm.vue?vue&type=script&lang=js"
export * from "./BindWeChatConfirm.vue?vue&type=script&lang=js"
import style0 from "./BindWeChatConfirm.vue?vue&type=style&index=0&id=267fa9c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267fa9c0",
  null
  
)

export default component.exports